

// -----------------------------详情页分期价动态变化-------------------------------
// 获取 .xianjia 盒子
const xianjiaBox = document.querySelector('.xianjia');

// 获取 .fenqijia 盒子
const fenqijiaBox = document.querySelector('.fenqijia');

// 定义一个函数，用于清理文本内容并将其转换为数字
function updateFenqijia() {
    // 获取 .xianjia 盒子的文本内容
    const textContent = xianjiaBox.textContent.trim();


    // 使用正则表达式匹配价格部分并将其转换为数字
    const match = textContent.match(/\$\d+(,\d+)?(\.\d+)?/);

    if (match) {
        const priceString = match[0].replace(/\$|,/g, ''); // 去除字符串中的美元符号和逗号
        const newPrice = parseFloat(priceString);

        const installmentPrice = newPrice / 4; // 将价格除以 4 得到分期价格

        const formattedPrice = '$' + installmentPrice.toFixed(2); // 添加美元符号和保留两位小数
        fenqijiaBox.textContent = formattedPrice;
    } else {
        console.error(".xianjia 盒子中的内容无法解析为价格。");
    }
}

// 页面加载完成后首次执行更新操作
updateFenqijia();

// 创建 MutationObserver 实例，监听 .xianjia 盒子的子节点变化
const observer = new MutationObserver(updateFenqijia);

// 配置 MutationObserver 监听子节点的变化
const config = { childList: true };

// 开始监听 .xianjia 盒子的变化
observer.observe(xianjiaBox, config);
